import React, {CSSProperties, Fragment, useEffect} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {useAutoHeightTextarea} from 'app/general/forms/auto-height-textarea-hook';
import {isRightToLeftWrapper} from 'app/utils/rtl';

const StyledTitleTextarea = styled.textarea.attrs<{className?: string}>({
  className: 'form-control mb-0',
  type: 'text',
  autoComplete: 'off',
})`
  letter-spacing: inherit;
  font-size: inherit;
  padding-top: 0;
  padding-bottom: 0;
`;

interface Props
  extends Pick<
    React.HTMLProps<HTMLTextAreaElement>,
    | 'maxLength'
    | 'autoFocus'
    | 'placeholder'
    | 'defaultValue'
    | 'type'
    | 'name'
    | 'readOnly'
    | 'onBlur'
    | 'onKeyPress'
  > {
  className?: string;
  onChange?: (value: string) => unknown;
  value?: string;
  style?: CSSProperties;
}

export function AutoHeightTitleInput({onChange, ...other}: Props) {
  const [autoHeightProps, AutoHeightGlobalStyle] = useAutoHeightTextarea({
    onChange,
    stripBreakLines: true,
  });

  useEffect(() => {
    autoHeightProps.ref.current?.focus();
  }, [other.value]);

  return (
    <Fragment>
      <StyledTitleTextarea
        {...other}
        {...autoHeightProps}
        className={cs(
          other.className,
          autoHeightProps.className,
          isRightToLeftWrapper(other.value || '') ? 'right-to-left-text' : ''
        )}
      />
      <AutoHeightGlobalStyle />
    </Fragment>
  );
}

// required for FormControlGroup magic (that's very gross, I know)
AutoHeightTitleInput.target = 'textarea';
